import api from "../../api"
import { getCoordinateObject } from "../../utils"
import adapterJoinRequests from "../join-requests/adapter"
import { subAdapter as singleSubAdapter } from "../organization/adapter"
import { NEED_TO_RE_FILTER_STATISTICS } from "./config"

const subAdapter = {
  ...singleSubAdapter,
  statistic: {
    responseBodyToRender(input, totalRegistered){
      let output = {}

      if(input && input.length > 0){
        let data = []
        let total = 0

        if(NEED_TO_RE_FILTER_STATISTICS === false){
          total = totalRegistered
        }

        for (let index = 0; index < input.length; index++) {
          const d = input[index];
          const name = d[0]
          const value = d[1]

          data.push({name, value})

          if(NEED_TO_RE_FILTER_STATISTICS === true){
            total += value
          }
        }

        // Sort from largest to smallest value
        const sorted = data.sort((a, b) => b.value - a.value)

        output = { data: sorted, total }
      }

      return output
    }
  }
}

const adapter = {
  responseBodyToRender(input){
    let output = {}

    if(input){
      const {
        highlight,
        deskripsi,
        lokasiOrganisasi = [],
        organisasiId,
        namaOrganisasi,
        imgMainImage,
        imgLogoOrganisasi,
        statusVerification,
        institutionProfile,
        teamMember = [],
        typeOrganisasi = [],
        tahunBerdiri,
        typeApproach = [],
        typeIssues = [],
        emailOrganisasi,
        teleponOrganisasi,
        milestoneOrganisasi = [],
        sosialMedia = [],
        requestedByIndividu = [],
        websiteOrganisasi,
        totalMember,
        binInstitutionProfile,
        createdAt,
        featuredContent = {}
      } = input

      const highlightAvailable = highlight && highlight !== null
      const descriptionAvailable = deskripsi && deskripsi !== null
      const lokasi = lokasiOrganisasi
      const location = lokasi && lokasi[0] ? `${lokasi[0].kota}, ${lokasi[0].provinsi}` : '-'
      const address = lokasi && lokasi[0] ? `${lokasi[0].jalan}` : '-'

      const pin_points = lokasiOrganisasi
        .filter(l => getCoordinateObject(l.pinLocation))
        .map((l, index) => {
          return {
            name: namaOrganisasi,
            id: namaOrganisasi+index,
            type: 'place',
            coordinate: getCoordinateObject(l.pinLocation),
            markerType: index === 0 ? 'headquarter' : 'place',
            content: `<div class="border-b border-solid mb-2 pb-2">${namaOrganisasi}</div><p>${l.jalan}, ${l.kota}, ${l.provinsi} ${l.kodePos || ''}</p>`,
          }
        })

      output = {
        id: organisasiId,
        created_at: createdAt,
        organizationId: organisasiId,
        name: namaOrganisasi,
        logo: api.base_image+imgLogoOrganisasi,
        image: api.base_image+imgMainImage,
        highlight_id: highlightAvailable ? highlight[0] : '',
        highlight_en: highlightAvailable ? highlight[1] : '',
        highlight: highlightAvailable ? {
          id: highlight[0],
          en: highlight[1]
        } : {
          id: undefined,
          en: undefined
        },
        description_id: descriptionAvailable ? deskripsi[0] : '',
        description_en: descriptionAvailable ? deskripsi[1] : '',
        description: descriptionAvailable ? {
          id: deskripsi[0],
          en: deskripsi[1]
        } : {
          id: undefined,
          en: undefined
        },
        status: statusVerification,
        institution: institutionProfile,
        types: typeOrganisasi,
        since: tahunBerdiri,
        approaches: typeApproach,
        location,
        address,
        issues: typeIssues,

        email: emailOrganisasi,
        phone: teleponOrganisasi,

        milestones: milestoneOrganisasi.map(m => subAdapter.milestone.responseBodyToRender(m)),
        socialLinks: sosialMedia.map(s => subAdapter.social_link.responseBodyToRender(s)),

        requests: requestedByIndividu.map(r => adapterJoinRequests.responseBodyToOrganizationForm(r)),
        members: teamMember ? teamMember.map(m => {
          return {
            joinId: m.pkJoinedOrganizationId,
            id: m.individu ? m.individu.userId : '',
            name: m.individu ? m.individu.namaIndividu : '',
            image: m.individu ? api.base_image+m.individu.imgFotoProfile : '',
            status: 'Joined',
            role: '-',
          }
        }) : [],
        website: websiteOrganisasi,
        profile: api.base_image+binInstitutionProfile,

        // Map Section Statistics
        total_member: teamMember ? teamMember.length : totalMember,
        total_cities: lokasiOrganisasi ? lokasiOrganisasi.length : 0,
        total_team: 0,
        total_activity: 0,

        // Map Data
        pin_points,

        featured_programs: subAdapter.programs.responseBodyToRender(featuredContent.featuredProgram),
        featured_programs_options: subAdapter.programs.responseBodyToOptions(featuredContent.featuredProgram)
      }
    }

    return output
  },
  responseBodyToProgramForm(input){
    let output

    if(input){
      const {
        teamMember = []
      } = input

      output = {
        members: teamMember.map(t => {
          return {
            id: t.individu.userId,
            name: t.individu.namaIndividu,
            image: api.base_image+t.individu.imgFotoProfile
          }
        }),
        members_options: teamMember.map(t => {
          return {
            label: t.individu.namaIndividu,
            value: t.individu.userId
          }
        })
      }
    }

    return output
  },
  responseBodyToOptions(input = []){
    let output = []

    if(input && input.length > 0){
      for (let index = 0; index < input.length; index++) {
        const {namaOrganisasi, organisasiId} = input[index];

        output.push({
          label: namaOrganisasi,
          value: organisasiId
        })
      }
    }

    return output
  },
  responseBodyToByProvince(input = []){
    let organizationsByProvince = {}
    let organizationsByProvinceByHub = {}
    let organizationsByProvinceByHubByType = {}

    if(input && input.length > 0){
      for (let index = 0; index < input.length; index++) {
        const organization = input[index];

        // Destructure organization fields
        const {
          organisasiId,
          namaOrganisasi,
          lokasiOrganisasi,
          headquarter = [],
          deskripsi = [],
          typeOrganisasi = []
        } = organization;

        const isHeadquarter = headquarter && headquarter.length > 0

        if(lokasiOrganisasi && lokasiOrganisasi.length > 0){
          lokasiOrganisasi.forEach(location => {
            const locationCloned = {...location}
            // Inject organization fields to location object
            locationCloned.organisasiId = organisasiId
            locationCloned.namaOrganisasi = namaOrganisasi
            locationCloned.isHeadquarter = isHeadquarter
            locationCloned.deskripsi = deskripsi
            locationCloned.typeOrganisasi = typeOrganisasi

            const provinceName = locationCloned.provinsi

            // By province
            if(!organizationsByProvince[provinceName]){
              organizationsByProvince[provinceName] = [locationCloned]
            } else {
              organizationsByProvince[provinceName].push(locationCloned)
            }

            // By hub (headquarter or not)
            if(isHeadquarter){
              if(!organizationsByProvinceByHub[provinceName]){
                organizationsByProvinceByHub[provinceName] = {
                  totalHeadquarter: 1,
                }
              } else {
                if(organizationsByProvinceByHub[provinceName].totalHeadquarter){
                  organizationsByProvinceByHub[provinceName].totalHeadquarter += 1
                } else {
                  organizationsByProvinceByHub[provinceName].totalHeadquarter = 1
                }
              }
            } else {
              if(!organizationsByProvinceByHub[provinceName]){
                organizationsByProvinceByHub[provinceName] = {
                  totalBranch: 1,
                }
              } else {
                if(organizationsByProvinceByHub[provinceName].totalBranch){
                  organizationsByProvinceByHub[provinceName].totalBranch += 1
                } else {
                  organizationsByProvinceByHub[provinceName].totalBranch = 1
                }
              }
            }

            let defaultValue = {
              headquarter: {},
              branch: {}
            }
            if(organizationsByProvinceByHubByType[provinceName]){
              defaultValue = {...organizationsByProvinceByHubByType[provinceName]}
            }
            organizationsByProvinceByHubByType[provinceName] = getByType(defaultValue, typeOrganisasi, isHeadquarter)
          });
        }
      }
    }

    return {
      organizationsByProvince,
      organizationsByProvinceByHub,
      organizationsByProvinceByHubByType
    }

    // Helpers
    function getByType(defaultValue, typeOrganisasi, isHeadquarter){
      let byType = {...defaultValue}
      if(typeOrganisasi && typeOrganisasi.length > 0){
        const LANGUAGE_INDEX = 1 // 0 = id, 1 = en

        typeOrganisasi.forEach(type => {
          if(type.nama && type.nama[LANGUAGE_INDEX]){
            const name = type.nama[LANGUAGE_INDEX]
            const id = type.id

            const hub = isHeadquarter ? 'headquarter' : 'branch'

            if(!byType[hub][name]){
              byType[hub][name] = {
                id,
                count: 1
              }
            } else {
              byType[hub][name].count += 1
            }
          }
        })
      }
      return byType
    }
  },
  byProvinceToByCity(input = {}){
    const {
      organizationsByProvince,
      organizationsByProvinceByHub,
      organizationsByProvinceByHubByType
    } = input

    let output = {}

    const provinceNames = Object.keys(organizationsByProvince)

    if(provinceNames.length > 0){
      provinceNames.forEach(provinceName => {
        const organizationsByCity = {}
        let organizationsByCityByType = {}
        const provinceLocations = organizationsByProvince[provinceName]

        provinceLocations.forEach(location => {
          const { kota, typeOrganisasi } = location
          const cityName = kota
          if(!organizationsByCity[cityName]){
            organizationsByCity[cityName] = [location]
          } else {
            organizationsByCity[cityName].push(location)
          }

          let defaultValue = {}
          if(organizationsByCityByType[cityName]){
            defaultValue = {...organizationsByCityByType[cityName]}
          }
          organizationsByCityByType[cityName] = getByType(defaultValue, typeOrganisasi)
        });

        const totalHeadquarter = organizationsByProvinceByHub[provinceName] && organizationsByProvinceByHub[provinceName].totalHeadquarter ? organizationsByProvinceByHub[provinceName].totalHeadquarter : 0

        const totalBranch = organizationsByProvinceByHub[provinceName] && organizationsByProvinceByHub[provinceName].totalBranch ? organizationsByProvinceByHub[provinceName].totalBranch : 0

        const metadata = Object.keys(organizationsByProvinceByHubByType[provinceName]).map(key => {
          return {
            name: key === 'headquarter' ? 'Headquarter' : 'Cabang',
            count: key === 'headquarter' ? totalHeadquarter : totalBranch,
            subData: Object.keys(organizationsByProvinceByHubByType[provinceName][key]).map(type => ({
              name: type,
              count: organizationsByProvinceByHubByType[provinceName][key][type].count,
              link: `/organization?type=${organizationsByProvinceByHubByType[provinceName][key][type].id}`
            }))
          }
        })

        output[provinceName] = {
          metadata,
          city: organizationsByCity,
          cityByType: organizationsByCityByType
        }
      });
    }

    return output

    // Helpers
    function getByType(defaultValue, typeOrganisasi){
      let byType = {...defaultValue}
      if(typeOrganisasi && typeOrganisasi.length > 0){
        const LANGUAGE_INDEX = 1 // 0 = id, 1 = en

        typeOrganisasi.forEach(type => {
          if(type.nama && type.nama[LANGUAGE_INDEX]){
            const name = type.nama[LANGUAGE_INDEX]
            const id = type.id

            if(!byType[name]){
              byType[name] = {
                id,
                count: 1
              }
            } else {
              byType[name].count += 1
            }
          }
        })
      }
      return byType
    }
  },
  responseBodyToMap(input = {}){
    let output = []

    const provinceNames = Object.keys(input)
    if(provinceNames.length > 0){
      provinceNames.forEach(provinceName => {
        const province = input[provinceName]
        const { city, metadata } = province

        const firstCityName = Object.keys(city)[0]
        const firstCity = city[firstCityName]
        const totalCity = Object.keys(city).length
        const firstLocation = firstCity[0]
        const coordinateString = firstLocation.pinLocation
        const coordinateObject = getCoordinateObject(coordinateString)

        if(provinceName !== 'N/A' && coordinateObject){
          output.push({
            name: provinceName,
            id: provinceName.toUpperCase().split(' ').join('_'),
            type: 'province',
            coordinate: coordinateObject,
            total: totalCity,
            markerType: 'organization',
            metadata,
            noInteraction: true,
          })
        }
      });
    }

    return output
  },
  responseBodyToMapNested(input = {}){
    let output = []

    const provinceNames = Object.keys(input)
    if(provinceNames.length > 0){
      provinceNames.forEach(provinceName => {
        const province = input[provinceName]
        const { city, metadata } = province

        const firstCityName = Object.keys(city)[0]
        const firstCity = city[firstCityName]
        const totalCity = Object.keys(city).length
        const firstLocation = firstCity[0]
        const coordinateString = firstLocation.pinLocation
        const coordinateObject = getCoordinateObject(coordinateString)

        if(provinceName !== 'N/A' && coordinateObject){
          output.push({
            name: provinceName,
            id: provinceName.toUpperCase().split(' ').join('_'),
            type: 'province',
            coordinate: coordinateObject,
            total: totalCity,
            link: `/organization?province=${provinceName}`,
            markerType: 'organization',
            metadata,
            places: generateCities(province)
          })
        }
      });
    }

    return output

    /** Helpers */
    function generateCities(province){
      const { city, cityByType } = province
      const citiesByName = city
      const output = []

      const cityNames = Object.keys(citiesByName)
      if(cityNames.length > 0){
        cityNames.forEach(cityName => {
          const locations = citiesByName[cityName]
          const firstLocation = locations[0]
          const totalLocation = locations.length
          const coordinateString = firstLocation.pinLocation
          const coordinateObject = getCoordinateObject(coordinateString)

          const metadata = Object.keys(cityByType[cityName]).map(type => {
            return {
              name: type,
              count: cityByType[cityName][type].count,
              link: `/organization?type=${cityByType[cityName][type].id}`,
            }
          })

          if(cityName !== 'N/A' && coordinateObject){
            output.push({
              name: cityName,
              id: cityName.toUpperCase().split(' ').join('_'),
              type: 'city',
              coordinate: coordinateObject,
              total: totalLocation,
              markerType: 'organization',
              link: `/organization?city=${cityName}`,
              metadata,
              places: adaptLocations(locations)
            })
          }
        });
      }

      return output
    }

    function adaptLocations(input){
      let output = []

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const location = input[index];
          const {
            organisasiId,
            namaOrganisasi,
            pinLocation,
            deskripsi,
            isHeadquarter,
            jalan
          } = location
          const coordinateString = pinLocation
          const coordinateObject = getCoordinateObject(coordinateString)

          if(namaOrganisasi !== 'N/A' && coordinateObject){
            output.push({
              name: namaOrganisasi,
              id: namaOrganisasi.toUpperCase().split(' ').join('_'),
              type: 'headquarter',
              coordinate: coordinateObject,
              markerType: isHeadquarter ? 'headquarter' : 'organization',
              link: `/organization/${organisasiId}`,
              content: {
                id: deskripsi?.[0],
                en: deskripsi?.[1]
              },
              address: jalan
            })
          }
        }
      }

      return output
    }
  },
  responseBodyToStatistic(input = {}){
    let output = {}

    if(input){
      const {
        // lokasiOrganisasiByJalan,
        lokasiOrganisasiByKota,
        // lokasiOrganisasiByPinLocation,
        // lokasiOrganisasiByProvinsi,
        typeApproach,
        // typeAudience,
        typeIssues,
        typeOrganisasi,
        organisasiTerdaftar
      } = input

      output = {
        organization: subAdapter.statistic.responseBodyToRender(typeOrganisasi, organisasiTerdaftar),
        approach: subAdapter.statistic.responseBodyToRender(typeApproach, organisasiTerdaftar),
        issues: subAdapter.statistic.responseBodyToRender(typeIssues, organisasiTerdaftar),
        location: subAdapter.statistic.responseBodyToRender(lokasiOrganisasiByKota, organisasiTerdaftar),
        province: subAdapter.statistic.responseBodyToRender(lokasiOrganisasiByKota, organisasiTerdaftar),
      }
    }

    return output
  }
}

export { subAdapter }

export default adapter
